// components/MicroFrontendWrapper.jsx
import PropTypes from "prop-types";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import FederatedMicroFrontend from "../../FederatedMicroFrontend";
import MicroFrontend from "../../MicroFrontend";
import SCAILayout from "../../components/SCAILayout";
import { useAuth } from "../../provider/AuthContext";
import { defaultHistory } from "../../history";

const SCAIFrontendWrapper = ({
  host,
  name,
  id,
  entry,
  requireAuth = false,
  federated = false,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated, selectedBusinessUnit } = useAuth();

  useEffect(() => {
    if (requireAuth && !isAuthenticated) {
      navigate("/");
    }
  }, [requireAuth, isAuthenticated, navigate]);
  // @originjs/vite-plugin-federation's remote-EXPOSE side has no dev-mode
  // implementation (devExposePlugin registers no virtual module or serving
  // path — only its build-mode counterpart actually emits a loadable
  // remoteEntry.js). That's a constraint on the REMOTE: whatever app exposes
  // "./bootstrap" must serve a real build artifact (its own `npm run build`
  // output, served statically — see each remote's own vite.config.js) even
  // while running its dev server, since Vite's dev-mode transform pipeline
  // won't generate one on the fly.
  //
  // It is NOT a constraint on the HOST. devRemotePlugin (the consuming
  // side) has a real `transform` hook that rewrites `import("<remote>/x")`
  // into working federation-loader calls, and it runs in `vite dev` the
  // same as in a build — so as long as the remote is actually serving a
  // real remoteEntry.js at its configured URL, module federation works from
  // this host in dev too. So the loader choice is exactly the `federated`
  // flag, full stop — no PROD gate.
  const useFederation = federated;
  const remoteKey = `${selectedBusinessUnit?.business_unit_id}-${location.pathname}`;

  return (
    <SCAILayout>
      <div id={id}>
        {useFederation ? (
          <FederatedMicroFrontend key={remoteKey} name={name} id={id} />
        ) : (
          <MicroFrontend
            key={remoteKey}
            history={defaultHistory}
            host={host}
            name={name}
            entry={entry}
          />
        )}
      </div>
    </SCAILayout>
  );
};

SCAIFrontendWrapper.propTypes = {
  host: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  entry: PropTypes.string,
  requireAuth: PropTypes.bool,
  federated: PropTypes.bool,
};

export default SCAIFrontendWrapper;
